const LV_CONVERSION_VERSION = 'v103';

const state = window.__lvProductConversionV84 || {
  listenersBound: false,
  productViewTracked: false,
  observedValues: new WeakSet(),
  playedVideos: new WeakSet(),
  activeTransformationVideos: new Set(),
  lastCartUpdate: 0,
  cartIntentAt: 0,
};
window.__lvProductConversionV84 = state;
state.activeTransformationVideos ||= new Set();

function syncReturnGuaranteeBanner() {
  state.activeTransformationVideos.forEach((video) => {
    if (!video.isConnected || video.paused || video.ended) state.activeTransformationVideos.delete(video);
  });

  const shouldHide = state.activeTransformationVideos.size > 0;
  document.querySelectorAll('[data-lv-return-guarantee-banner]').forEach((banner) => {
    banner.hidden = shouldHide;
    if (shouldHide) banner.setAttribute('aria-hidden', 'true');
    else banner.removeAttribute('aria-hidden');
  });
}

function transformationVideoFromEvent(event) {
  const video = event.target instanceof HTMLVideoElement ? event.target : null;
  return video?.closest('.lv-product-media--transformation') ? video : null;
}

function productHandle() {
  return document.querySelector('[data-lv-value-summary]')?.dataset.productHandle || '';
}

function anonymousSessionId() {
  const storageKey = 'veloraAnonymousFunnelSessionV1';
  try {
    let sessionId = window.sessionStorage.getItem(storageKey);
    if (!sessionId) {
      const randomId = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
      sessionId = `lv-${randomId}`;
      window.sessionStorage.setItem(storageKey, sessionId);
    }
    return sessionId;
  } catch (_error) {
    return '';
  }
}

function marketingContext() {
  const storageKey = 'veloraMarketingContextV1';
  const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const params = new URLSearchParams(window.location.search);
  const current = Object.fromEntries(allowed
    .map((key) => [key, params.get(key) || ''])
    .filter(([, value]) => value));

  try {
    if (Object.keys(current).length) window.sessionStorage.setItem(storageKey, JSON.stringify(current));
    if (!Object.keys(current).length) return JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
  } catch (_error) {
    return current;
  }
  return current;
}

function clarityEvent(name, value = '') {
  if (typeof window.clarity !== 'function') return;
  window.clarity('event', name);
  window.clarity('set', 'velora_version', LV_CONVERSION_VERSION);
  if (value) window.clarity('set', name, String(value));
}

function track(name, detail = {}, { dataLayer = true } = {}) {
  const eventName = `velora_${name}`;
  const payload = {
    event: eventName,
    version: LV_CONVERSION_VERSION,
    landing_version: LV_CONVERSION_VERSION,
    product_handle: productHandle(),
    variant_id: document.querySelector('product-form-component input[name="id"]')?.value || '',
    funnel_session_id: anonymousSessionId(),
    viewport: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    ...marketingContext(),
    ...detail,
  };

  if (dataLayer) {
    if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
    window.dataLayer.push(payload);
  }

  clarityEvent(eventName, detail.value || detail.style || detail.state || '');
  document.dispatchEvent(new CustomEvent('velora:conversion', { detail: payload }));
  return payload;
}

window.__lvTrackConversionV103 = track;

function observeValueSummary(root = document) {
  // Demo markup is rendered only by the dedicated, unpublished preview theme.
  root.querySelectorAll('[data-lv-demo-baskets]').forEach((notice) => {
    if (notice.dataset.lvDemoBound) return;
    notice.dataset.lvDemoBound = 'true';
    const update = () => {
      if (!notice.isConnected) return;
      const turkeyNow = Date.now() + 3 * 60 * 60 * 1000;
      const slot = 4 * 60 * 60 * 1000;
      const count = Math.floor(turkeyNow / slot) % 3 + 2;
      notice.textContent = notice.dataset.lvDemoLanguage === 'en'
        ? `In ${count} shoppers’ carts` : `${count} kişinin sepetinde`;
      window.setTimeout(update, slot - (turkeyNow % slot) + 50);
    };
    update();
  });
  root.querySelectorAll('[data-lv-notice-expires]').forEach((notice) => {
    if (notice.dataset.lvExpiryBound) return;
    notice.dataset.lvExpiryBound = 'true';
    const remaining = Date.parse(notice.dataset.lvNoticeExpires) - Date.now();
    if (!Number.isFinite(remaining) || remaining <= 0) notice.hidden = true;
    else window.setTimeout(() => { notice.hidden = true; }, Math.min(remaining, 2147483647));
  });
  root.querySelectorAll('[data-lv-value-summary]').forEach((summary) => {
    if (state.observedValues.has(summary)) return;
    state.observedValues.add(summary);

    if (!('IntersectionObserver' in window)) {
      track('product_value_seen');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.55)) return;
      track('product_value_seen');
      observer.disconnect();
    }, { threshold: [0.55] });
    observer.observe(summary);
  });
}

function trackProductView() {
  if (state.productViewTracked || !productHandle()) return;
  state.productViewTracked = true;
  track('product_view', {
    page_template: document.querySelector('main[data-template]')?.dataset.template || 'product',
  });
}

function panelFor(trigger) {
  const panelId = trigger.getAttribute('aria-controls');
  return panelId ? document.getElementById(panelId) : null;
}

function closeOtherDisclosures(exceptTrigger) {
  document.querySelectorAll('[data-lv-family-trigger][aria-expanded="true"]').forEach((trigger) => {
    if (trigger === exceptTrigger) return;
    const panel = panelFor(trigger);
    if (panel) panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  });
}

function setFamilyPanel(trigger, open, restoreFocus = true) {
  const panel = panelFor(trigger);
  if (!panel) return;

  if (open) closeOtherDisclosures(trigger);
  panel.hidden = !open;
  trigger.setAttribute('aria-expanded', String(open));
  if (open) {
    track('family_models_open');
    panel.querySelector('[data-lv-family-close]')?.focus({ preventScroll: true });
  } else if (restoreFocus) {
    trigger.focus({ preventScroll: true });
  }
}

function bindGlobalListeners() {
  if (state.listenersBound) return;
  state.listenersBound = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const returnTrigger = target.closest('[data-lv-return-guarantee-trigger]');
    if (returnTrigger) {
      track('return_details_open', {
        source: returnTrigger.dataset.lvReturnTriggerSource || 'return-guarantee',
      });
    }

    const familyTrigger = target.closest('[data-lv-family-trigger]');
    if (familyTrigger) {
      event.preventDefault();
      setFamilyPanel(familyTrigger, familyTrigger.getAttribute('aria-expanded') !== 'true');
      return;
    }

    const familyClose = target.closest('[data-lv-family-close]');
    if (familyClose) {
      event.preventDefault();
      const panel = familyClose.closest('[data-lv-family-panel]');
      const trigger = panel?.id ? document.querySelector(`[aria-controls="${panel.id}"]`) : null;
      if (trigger) setFamilyPanel(trigger, false);
      return;
    }

    const familyModel = target.closest('[data-lv-family-model]');
    if (familyModel) {
      track('family_model_select', { value: familyModel.dataset.modelHandle || '' });
    }

    if (target.closest('[data-lv-value-review]')) track('value_review_open');

    const decisionSummary = target.closest('[data-lv-decision-details] > summary');
    if (decisionSummary) {
      track('decision_details_toggle', {
        state: decisionSummary.parentElement?.open ? 'closed' : 'open',
      });
    }

    if (target.closest('[data-lv-fit-support]')) track('laptop_fit_support_click');

    const featuresSummary = target.closest('[data-lvpa-summary]');
    if (featuresSummary) {
      const stateName = featuresSummary.parentElement?.open ? 'closed' : 'open';
      track('features_panel_toggle', { state: stateName });
    }
    if (target.closest('[data-lvpa-collapse]')) {
      track('features_panel_toggle', { state: 'closed' });
    }

    if (target.closest('button[name="add"], [data-confirm-cart]')) {
      state.cartIntentAt = Date.now();
      track('add_to_cart_intent', {
        placement: target.closest('[data-confirm-cart]')
          ? 'atelier'
          : (target.closest('sticky-add-to-cart') ? 'sticky' : 'main'),
      });
    }

    if (target.closest('#lv-buynow-btn, [data-confirm-checkout]')) {
      state.cartIntentAt = Date.now();
      track('checkout_intent', {
        placement: target.closest('[data-confirm-checkout]') ? 'atelier' : 'main',
      });
    }
  });

  document.addEventListener('play', (event) => {
    const video = transformationVideoFromEvent(event);
    if (!video) return;

    state.activeTransformationVideos.add(video);
    video.closest('.lv-product-media--transformation')?.classList.add('is-playing');
    syncReturnGuaranteeBanner();

    if (state.playedVideos.has(video)) return;
    state.playedVideos.add(video);
    const mediaContainer = video.closest('.product-media-container');
    const siblings = mediaContainer?.parentElement
      ? [...mediaContainer.parentElement.children].filter((item) => item.matches?.('.product-media-container'))
      : [];
    track('transformation_video_play', { media_position: Math.max(1, siblings.indexOf(mediaContainer) + 1) });
  }, true);

  const restoreReturnBanner = (event) => {
    const video = transformationVideoFromEvent(event);
    if (!video) return;
    state.activeTransformationVideos.delete(video);
    video.closest('.lv-product-media--transformation')?.classList.remove('is-playing');
    syncReturnGuaranteeBanner();
  };

  document.addEventListener('pause', restoreReturnBanner, true);
  document.addEventListener('ended', restoreReturnBanner, true);
  document.addEventListener('emptied', restoreReturnBanner, true);

  document.addEventListener('slideshow:select', (event) => {
    const selectedSlide = event.detail?.slide;
    state.activeTransformationVideos.forEach((video) => {
      if (!(selectedSlide instanceof Element) || !selectedSlide.contains(video)) video.pause();
    });
    syncReturnGuaranteeBanner();
  });

  document.addEventListener('velora:style_selected', (event) => {
    if (event.detail?.landing_version === LV_CONVERSION_VERSION) return;
    const style = event.detail?.style || '';
    clarityEvent('velora_style_selected', style);
  });

  document.addEventListener('cart:update', () => {
    const now = Date.now();
    if (!productHandle() || !state.cartIntentAt || now - state.cartIntentAt > 20000 || now - state.lastCartUpdate < 800) return;
    state.lastCartUpdate = now;
    state.cartIntentAt = 0;
    track('add_to_cart_success');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = document.querySelector('[data-lv-family-panel]:not([hidden])');
    const trigger = panel?.id ? document.querySelector(`[aria-controls="${panel.id}"]`) : null;
    if (!trigger) return;
    setFamilyPanel(trigger, false);
  });

  document.addEventListener('shopify:section:load', (event) => {
    observeValueSummary(event.target);
    syncReturnGuaranteeBanner();
  });
}

bindGlobalListeners();
observeValueSummary();
syncReturnGuaranteeBanner();
trackProductView();
